import comp from "./JumpToSkeletonLoader";

export default comp;
